var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultFaqs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.467 18.934v0A7.467 7.467 0 014 11.467v0A7.467 7.467 0 0111.467 4v0a7.467 7.467 0 017.467 7.467v0a7.467 7.467 0 01-7.467 7.467z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.467 12.504v-.207c0-.678.42-1.045.84-1.327.41-.276.82-.636.82-1.3a1.659 1.659 0 00-3.319-.001M11.466 14.843a.148.148 0 00-.149.15.15.15 0 10.149-.15M20 20l-3.25-3.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgConsultFaqs;